import { createRouter, createWebHistory } from "vue-router";
import H from "./views/H2.vue";

// history: createWebHistory(import.meta.env.BASE_URL),

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 };
  },


routes: [
    {
      path: "/",
      name: "Home",
      component: H,
    },




    {
      path: "/Login",
      name: "Login",
      component: () => import("./views/Login.vue"),
      meta: { requiresAuth: false },
    },

    {
      path: "/Platform",
      name: "Platform",
      component: () => import("./views/Platform.vue"),
      meta: { requiresAuth: false },
    },


    // {
    //   path: "/Connect",
    //   name: "Connect",
    //   component: () => import("./views/Connect.vue"),
    //   meta: { requiresAuth: true },
    // },

    {
      path: "/Build",
      name: "Build",
      component: () => import("./views/Build.vue"),
      meta: { requiresAuth: true },
    },

    {
      path: "/Optimize",
      name: "Optimize",
      component: () => import("./views/Optimize.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/method",
      name: "method",
      component: () => import("./views/Method.vue"),
      meta: { requiresAuth: false },
    },


    {
      path: "/Manage",
      name: "Manage",
      component: () => import("./views/Manage.vue"),
      meta: { requiresAuth: false }, 

    },

    {
      path: "/Operate",
      name: "Operate",
      component: () => import("./views/Operate.vue"),
      meta: { requiresAuth: false }, 

    },
    
    {
      path: "/Connect",
      name: "Connect",
      component: () => import("./views/GetStarted.vue"),
      meta: { requiresAuth: true },    },


    {
      path: "/Community",
      name: "Community",
      component: () => import("./views/Community.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/OC-Connect",
      name: "OC-Connect",
      component: () => import("./views/Connect.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/Research",
      name: "Research",
      component: () => import("./views/Research.vue"),
      meta: { requiresAuth: false },
    },
    {
      path: "/Company",
      name: "Company",
      component: () => import("./views/Company.vue"),
      meta: { requiresAuth: false },
    },

    {
      path: "/Report",
      name: "Report",
      component: () => import("./views/Report.vue"),
      meta: { requiresAuth: false },
    },

      {
      path: "/Team",
      name: "Team",
      component: () => import("./views/Team.vue"),
      meta: { requiresAuth: false },
    },

  ],
});

export default router;
